// Per-post meta description + og:description.
export default function description(pageContext: Vike.PageContext): string {
  const post = (pageContext.data as { post?: { excerpt?: string | null } } | undefined)?.post;
  return (
    post?.excerpt ||
    'Thoughts on sports betting, life, and more from Eddie Walls — long-time pro bettor and RAS team member.'
  );
}
